<div style="height: 100%" cdkScrollable>
  <div style="height: 100%" fxLayout="column" fxLayoutAlign="space-between">
    <div style="width: 100%">
      <section class="mt-20">
        <h3>
          {{
            selectedEvent?.eventType == SchedulerEventType.Reserved
              ? 'Reserve Timeslot'
              : 'Booking details'
          }}
        </h3>
      </section>
      <mat-divider></mat-divider>
      <section class="scrollable">
        <div fxLayout="column">
          <div *ngIf="selectedEvent?.actionNumber" class="booking-details-row">
            <mat-label><strong>Court Case</strong></mat-label>
            <mat-label>{{
              selectedEvent?.actionNumber ? selectedEvent.actionNumber : '--'
            }}</mat-label>
          </div>
          <mat-divider *ngIf="selectedEvent?.actionNumber"></mat-divider>
          <div *ngIf="selectedEvent?.actionTitle" class="booking-details-row">
            <mat-label><strong>Style of cause / ITMO</strong></mat-label>
            <mat-label>{{
              selectedEvent?.actionTitle ? selectedEvent.actionTitle : '--'
            }}</mat-label>
          </div>
          <mat-divider *ngIf="selectedEvent?.actionTitle"></mat-divider>
          <div class="booking-details-row">
            <mat-label><strong>Date</strong></mat-label>
            <mat-label>
              {{
                selectedEvent && selectedEvent?.start
                  ? (selectedEvent?.start | date: 'fullDate')
                  : '--'
              }}</mat-label
            >
          </div>
          <mat-divider></mat-divider>
          <div class="booking-details-row">
            <mat-label><strong>Time</strong></mat-label>
            <mat-label>
              <span
                *ngIf="selectedEvent && selectedEvent?.start; else elseBlock"
              >
                {{
                  (selectedEvent.start | date: 'shortTime') +
                    ' - ' +
                    (selectedEvent.end | date: 'shortTime') +
                    ' MST'
                }}
              </span>
              <ng-template #elseBlock> -- </ng-template>
            </mat-label>
          </div>
          <mat-divider></mat-divider>
          <div class="booking-details-row">
            <mat-label><strong>Duration</strong></mat-label>
            <mat-label
              >{{ duration ? duration + ' minutes' : '--' }}
            </mat-label>
          </div>
        </div>
      </section>
    </div>
    <div>
      <section class="mt-20 mb-20">
        <ng-container
          *ngIf="
            selectedEvent?.eventType == SchedulerEventType.Hearing;
            else reserveButtonBlock
          "
        >
          <button
            [disabled]="
              !selectedEvent?.hearingRequestId ||
              selectedEvent?.eventType != SchedulerEventType.Hearing ||
              selectedEvent.fromQBSS
            "
            mat-flat-button
            color="primary"
            (click)="onGoToRequest()"
          >
            Go to request
          </button>
        </ng-container>

        <ng-template #reserveButtonBlock>
          <ng-container
            *ngIf="
              selectedEvent?.eventType == SchedulerEventType.Reserved;
              else urgentButtonBlock
            "
          >
            <button
              [disabled]="selectedEvent.hearingRequestId"
              mat-flat-button
              color="primary"
              (click)="onReserveTimeslot()"
            >
              Reserve
            </button>
          </ng-container>
        </ng-template>

        <ng-template #urgentButtonBlock>
          <div
            fxLayout="row"
            fxLayoutAlign="start"
            fxLayoutGap="{{ FlexLayoutType.Gap.XSmall }}"
          >
            <button
              style="min-width: 55%"
              mat-stroked-button
              color="primary"
              (click)="onReturnToHearingRequest()"
            >
              Return to request
            </button>
            <button
              style="min-width: 40%"
              [disabled]="!selectedEvent?.start"
              mat-flat-button
              color="primary"
              (click)="onSelectUrgentRequestDate()"
            >
              Save
            </button>
          </div>
        </ng-template>
      </section>
    </div>
  </div>
</div>
